export const shortTimeFormat = 'HH:mm';
export const fullDateFormat = 'dd.MM.yyyy';
export const fullDateShortTimeFormat = 'dd.MM.yyyy HH:mm';
export const shortDateFullMonthFormat = 'd MMMM';
export const shortDateFullMonthFullYearFormat = 'd MMM yyyy';
